import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
  createRef,
  Fragment,
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import { useSearchParams } from "react-router-dom";
import { IPurchaseOrder, IPurchaseOrderProps } from "./IPurchaseOrder";
import {
  Autocomplete,
  Backdrop,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import { editPurchaseOrderStart } from "../../redux/purchase-order/editPurchaseOrder";

const PurchaseOrderForm: FunctionComponent<IPurchaseOrderProps> = (props) => {
  const { handleClose, setInitialValues, initialValues } = props;
  const [isEdit, setEdit] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const { data: editPurchase, isLoading: editPurchaseOrder } = useAppSelector(
    (state) => state.EditPurchaseOrder
  );

  //   validation
  const validationSchema = Yup.object().shape({
    id: Yup.number().optional(),
    reason: Yup.string()
      .min(1, "Reason Required")
      .max(50, "Reason exceed maximum length of 50 chracters")
      .required("Reason Required"),
  });

  const formik = useFormik<IPurchaseOrder>({
    enableReinitialize: true,
    initialValues: {
      reason: "",
      active: initialValues?.active ? initialValues.active : true,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("values", values);

      submit(values);
    },
  });
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
    setValues,
    validateForm,
  } = formik;

  console.log(touched);
  console.log("errors", errors);

  const submit = (a: IPurchaseOrder) => {
    if (a.id) {
      console.log("foem submitting value", {
        ...a,
        ApprovalStatus: "N",
      });
      dispatch(editPurchaseOrderStart({ ...a, ApprovalStatus: "N" }));
    }
  };

  useEffect(() => {
    if (initialValues?.id) {
      setValues(initialValues);
    }
    return () => {
      setInitialValues({});
    };
  }, []);

  useEffect(() => {
    if (editPurchase?.status) {
      handleClose();
    }
  }, [editPurchase]);

  return (
    <Fragment>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div className="field_item">
                <label className="f4">
                  Reason <span>*</span>
                </label>
                <TextField
                  fullWidth
                  className="custom_textfield"
                  name="reason"
                  multiline
                  value={values.reason}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  rows={4}
                  error={touched.reason && errors.reason ? true : false}
                  helperText={
                    touched.reason && errors.reason ? errors.reason : ""
                  }
                />
              </div>
            </Grid>
          </Grid>
        </form>

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={!!editPurchaseOrder}
        >
          <img
            style={{
              height: "150px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>
      </DialogContent>

      <DialogActions>
        <div className="dialog_footer">
          <Button
            onClick={() => {
              handleClose();
              setEdit(false);
            }}
            className="common_btn_outline"
          >
            Cancel
          </Button>

          <Button
            className="common_btn"
            onClick={() => {
              handleSubmit();
              validateForm();
            }}
          >
            {editPurchaseOrder ? "Please Wait..." : "Save"}
          </Button>
        </div>
      </DialogActions>
    </Fragment>
  );
};

export default PurchaseOrderForm;
